<template>
  <section class="categoryManage" id="categoryManage">
    <viewTitle
      title="业务管理 / 审批跳过情况汇总 / 消息管理"
      :showReturn="false"
    />

    <!-- 按钮组1 -->
    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-button type="primary" @click="modifyTpl('', 'add')" size="small">
          新建消息
        </el-button>
        <!-- </div> -->
        <!-- </section> -->
        <!-- 按钮组2 -->
        <!-- <section class="controler"> -->
        <!-- <div class="ctrLeft" style="width: 100%;"> -->
        <span class="rectl">类别: </span>
        <el-select
          class="ctl"
          v-model="params.class_id"
          placeholder="请选择"
          clearable
          @clear="params.class_id = ''"
          @change="changeState"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="item in categoryOptions"
            :key="item.id"
          ></el-option>
        </el-select>
        <el-input
          class="ctl rectl"
          style="width: 20% !important;"
          clearable
          placeholder="输入关键字搜索"
          suffix-icon="el-icon-search"
          v-model="params.keyword"
          @change="changeKeyword"
        ></el-input>
        <el-button
          class="rectl"
          type="primary"
          @click="refreshData"
          size="small"
        >
          刷新数据
        </el-button>
      </div>
    </section>

    <!-- 列表 -->
    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
      >
        <el-table-column label="消息类别">
          <template slot-scope="scope">
            {{ scope.row.class_name || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="消息标题">
          <template slot-scope="scope">
            {{ scope.row.title || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="实际发送时间">
          <template slot-scope="scope">
            {{
              scope.row.push_time === 0 || scope.row.push_time === null
                ? "--"
                : formatTime(scope.row.push_time)
            }}
          </template>
        </el-table-column>
        <el-table-column label="定时发送时间">
          <template slot-scope="scope">
            {{
              scope.row.publish_timing === 0 ||
              scope.row.publish_timing === null
                ? "--"
                : formatTime(scope.row.publish_timing)
            }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 0" class="color99">未推送</span>
            <span v-if="scope.row.state === 1" class="color5E">已推送</span>
            <span v-if="scope.row.state === 2" class="color67">推送出错</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="dropdown" @click.stop>
              <el-dropdown trigger="click" :hide-on-click="true">
                <span class="el-dropdown-link">
                  操作
                  <span class="el-icon-arrow-down"></span>
                </span>
                <el-dropdown-menu slot="dropdown" ref="dropdown">
                  <el-dropdown-item @click.native.stop="viewDetail(scope.row)"
                    >查看详情</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="modifyTpl(scope.row, 'edit')"
                    >再次发送</el-dropdown-item
                  >
                  <el-dropdown-item @click.native.stop="viewQrCode(scope.row)"
                    >扫码预览</el-dropdown-item
                  >
                  <el-dropdown-item
                    @click.native.stop="delOrEnable(scope.row, 'del')"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-wrap">
        <pagi
          :page="page"
          :pageSize="pageSize"
          :count="count"
          @pageChange="pageChange"
        ></pagi>
      </div>
    </section>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.show"
      width="30%"
      :show-close="dialogParams.title === '确认提醒'"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div style="font-size: 18px;">
          <i
            class="el-icon-success"
            style="color: #2acdcf;"
            v-if="dialogParams.title === '操作成功'"
          ></i>
          {{ dialogParams.title }}
        </div>
      </template>
      <div>
        <div v-html="dialogParams.content"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.show = false" size="small">
          <span v-if="dialogParams.title === '确认提醒'">取 消</span>
          <span v-else>我知道了</span>
        </el-button>
        <el-button
          size="small"
          :class="dialogParams.type === 'del' ? 'btnConfirmDanger' : ''"
          :type="dialogParams.type === 'del' ? 'danger' : 'primary'"
          @click="confirm"
          v-loading.fullscreen.lock="fullscreenLoading"
          v-if="dialogParams.title === '确认提醒'"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.qrCodeShow"
      width="30%"
      :show-close="false"
      title="扫描二维码预览"
      :close-on-click-modal="false"
    >
      <div style="display: flex;justify-content: center;">
        <div id="qrcode"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.qrCodeShow = false" size="small">
          <span>关 闭</span>
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import pagi from "@/components/pagi/pagi";
import viewTitle from "@/components/viewTitle";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import keepAliveMinxin from "@/mixins/rh/keepAliveMinxin.js";
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      // module_name: "services-advice",
      tabPosition: "left",
      page: 1,
      pageSize: 50,
      count: 0, // 表格总数
      domain: "",
      previewKey: "",
      comId: "",
      appId: "",
      rowDataObj: {},
      params: {
        keyword: "", // 关键字搜索
        class_id: "" // 分类记录id
      },
      dialogParams: {
        show: false,
        title: "",
        content: "",
        type: "",
        showModify: false, // 编辑
        typeModify: "", // 编辑/添加
        qrCodeShow: false // 二维码显示
      },
      modifyParams: {
        id: 0, // id
        name: "", // 类别名称
        remark: "", // 备注
        serviceInclude: [], // 包含业务(复选框)
        include: {} // 下拉选择框
      },
      fullscreenLoading: false,
      maxSize: 0,
      tableData: [], // 表格数据
      categoryOptions: [
        {
          name: "全部",
          id: ""
        }
      ],
      toKeepAlivePath: "/rhqy/service/approval/info/detail" // 当前路由访问某个页面时的不清除缓存
    };
  },

  mixins: [mixinTableLyout, keepAliveMinxin],

  components: {
    pagi,
    viewTitle
  },

  computed: {
    isOverSize() {
      return this.tableData.length > 0;
    }
  },

  mounted() {
    // this.getList();
    this.getCategoryList();
  },

  async activated() {
    this.getList();
  },

  created() {},

  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 切换页码
    pageChange(page) {
      this.page = page;
      this.getList();
    },

    // 关键字搜索
    changeKeyword(val) {
      this.page = 1;
      this.params.keyword = val;
      this.getList();
    },

    // 获取列表
    async getList() {
      let dataObj = await this.$common.http({
        url: "/api/psummary/admin/list_summary",
        data: {
          keyword: this.params.keyword,
          class_id: this.params.class_id,
          page_size: this.pageSize,
          page: this.page
        }
      });
      this.domain = dataObj.data.data.preview_domain;
      this.appId = dataObj.data.data.app_id;
      this.comId = dataObj.data.data.com_id;
      this.tableData = dataObj.data.data.items;
      this.count = dataObj.data.data.total;
    },

    // 获取类别列表
    async getCategoryList() {
      let dataObj = await this.$common.http({
        url: "/api/psummary/admin/list_class",
        data: {
          page: 1,
          page_size: 9999999
        }
      });
      let obj = dataObj.data.data;
      obj.items.forEach(item => {
        this.categoryOptions.push(item);
      });
    },

    // 修改状态
    changeState() {
      this.page = 1;
      this.getList();
    },

    // 刷新数据
    refreshData() {
      this.page = 1;
      this.getList();
    },

    // 查看详情
    viewDetail(item) {
      this.$router.push({
        path: "/rhqy/service/approval/info/detail",
        query: {
          id: item.id,
          domain: this.domain,
          comId: this.comId,
          appId: this.appId
        }
      });
    },

    // 编辑
    modifyTpl(item, tag) {
      this.$router.push({
        path: "/rhqy/service/approval/info/modify",
        query: {
          type: tag,
          id: item.id
        }
      });
    },

    // 删除/禁用启用
    delOrEnable(row, tag) {
      this.dialogParams.type = tag;
      this.dialogParams.title = "确认提醒";
      this.dialogParams.show = true;
      this.rowDataObj = row;
      if (tag === "del") {
        this.dialogParams.content = `确认要删除“<span class="color67">${this.rowDataObj.title}</span>”吗？<br />
        <span class="color67">删除后不可恢复！</span>`;
      }
    },

    // 确认删除
    confirm() {
      this.dialogParams.show = false;
      let url = "";
      if (this.dialogParams.type === "del") {
        url = "/api/psummary/admin/delete_summary";
      }
      this.$common
        .http({
          url: url,
          data: {
            id: this.rowDataObj.id
          }
        })
        .then(res => {
          console.log(res);
          if (this.dialogParams.type === "del") {
            this.$common.pcToastSuccess(
              `已成功删除“${this.rowDataObj.title}”。`
            );
            // this.dialogParams.content = `已成功删除“<span class="color67">${this.rowDataObj.title}</span>”类别。`;
          }
          // this.dialogParams.show = true;
          // this.dialogParams.title = "操作成功";
          this.getList();
          // setTimeout(() => {
          //   this.dialogParams.show = false;
          // }, 1500);
        });
    },

    // 保存表单
    save() {
      console.log("保存", this.modifyParams);
      if (this.modifyParams.name.trim() === "") {
        this.$common.pcToastFail("类别名称不能为空");
        return false;
      }
      if (this.modifyParams.remark.trim().length > 50) {
        this.$common.pcToastFail("备注不能超过50个字符");
        return false;
      }

      let idsObj = {};
      for (let i = 0; i < this.modifyParams.serviceInclude.length; i++) {
        idsObj[this.modifyParams.serviceInclude[i]] = this.modifyParams.include[
          this.modifyParams.serviceInclude[i]
        ];
      }

      this.$common
        .http({
          url: "/api/queue/admin/save_unit_class",
          data: {
            id: this.modifyParams.id,
            name: this.modifyParams.name,
            note: this.modifyParams.remark,
            business_ids: JSON.stringify(idsObj)
          }
        })
        .then(res => {
          console.log(res);
          this.dialogParams.showModify = false;
          if (res.data.data) {
            if (this.dialogParams.typeModify === "add") {
              this.$common.pcToastSuccess("添加成功");
            } else {
              this.$common.pcToastSuccess("保存成功");
            }
          }
          this.getList();
          // 重置表单
          this.modifyParams.serviceInclude = [];
          this.modifyParams.id = 0;
          this.modifyParams.name = "";
          this.modifyParams.remark = "";
          for (let i = 0; i < this.categoryOptions.length; i++) {
            this.modifyParams.include[this.categoryOptions[i].id] = [];
          }
        });
    },

    // 预览二维码
    viewQrCode(item) {
      this.dialogParams.qrCodeShow = true;
      let url = `${this.domain}/rhwx/index.html#/rhwxApprovalInfo?id=${item.id}&type=list&com_id=${this.comId}&app_id=process_pass`;
      console.log(url);
      setTimeout(() => {
        document.getElementById("qrcode").innerHTML = "";
        new QRCode("qrcode", {
          text: url,
          width: 260,
          height: 260
        });
      }, 100);
    },

    // 取消
    cancel() {
      this.dialogParams.showModify = false;
      this.modifyParams.serviceInclude = [];
      this.modifyParams.id = 0;
      this.modifyParams.name = "";
      this.modifyParams.remark = "";
      for (let i = 0; i < this.categoryOptions.length; i++) {
        this.modifyParams.include[this.categoryOptions[i].id] = [];
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.categoryManage {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }
  & > .controler {
    display: flex;
    margin-bottom: 16px;
    .ctl {
      display: inline-block;
      width: 10% !important;
    }
    .rectl {
      margin-left: 15px;
    }
    .ctl.mid {
      width: 16% !important;
    }
    .ctl.lar {
      width: 22% !important;
    }
    .ctrRight {
      float: right;
      margin: 0;
    }
    .ctl_fix {
      margin-top: -1px;
      margin-bottom: 0;
      line-height: 18px;
      vertical-align: middle;
      padding: 0 8px 0 10px;
      .el-range__close-icon {
        position: absolute;
        top: 0px;
        right: 2px;
      }
    }
  }
  & > .main-table {
    width: 100%;
    height: calc(100% - 169px);
    position: relative;
  }
  .page-wrap {
    padding-top: 10px;
  }
}
.el-checkbox,
.el-checkbox__input {
  white-space: normal;
  word-break: break-all;
}
</style>
<style lang="less">
#categoryManage .el-checkbox__label {
  width: 70%;
  vertical-align: text-top;
}
</style>
